export const fetchConfig = () => {
  const $http = angular.injector(['ng']).get('$http');
  return $http({
    method: 'GET',
    url: '/config/config.json',
    error: {
      silent: true,
    },
  });
};
